import DemoForm from "./demoForm";

export default function Demo() {
  return (
    <div className="flex flex-col items-center justify-center mt-[50px]">
      <DemoForm />
    </div>
  );
}
